import React from "react";
import "./About.css";
import aboutme from "../../assets/my-pic.png";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";
const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={aboutme} alt="" />
          </div>
        </div>

        <div className="about__conntent">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experince</h5>
              <small>3+ Years Working</small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>20+ Worldwide</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>50+</small>
            </article>
          </div>

          <p>
            Professional software engineer with an experience in software
            development, web development, and mobile app development. I have
            expertise in Javascript, ReactJS, Redux, Angular, Tailwind, Material
            UI, Firebase, and so on. <br />
            <br />
            At the moment, I'm working full time as a Software Engineer at
            Cinnova Technologies, LLC, where I also support the best team ever
            creating memorable brands and identities. <br />
            <br />
            When I'm not developing, you can find me spending quality time with
            my family, working out, hiking and generally spending time outdoors
            (but also playing table tennis and snooker).
          </p>

          <a href="#conntact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
